export default function seoImagesWidget() {
  const widgetName = 'seoImagesWidget';
  const widgetOpts = seoImagesWidgetOpts;
  const $widget = $(`#${widgetName}`);
  const wrapContainerClass = 'seoImagesWidget-container-wrapper';

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: [],
    moreButton: false,
    showDescription: false,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    textOverImage: false,
    maxItemsVisible: 2,
    itemsPerPanel: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        $widget.wrap(
          `<div class="${wrapContainerClass}"><div class="inner-container"></div></div>`,
        );
      } else {
        $(`.${wrapContainerClass}`).remove();
      }
    },
  });
}
